export enum DOWNLOAD_FILE_TYPE {
  ERIC_DECISION = "eric_decision",
  ERIC_DIVA_DECISION = "eric_diva_decision",
  STATEMENT = "eric_statement",
  FREELANCE_EUER = "freelance_euer",
  GEWERBE_EUER = "gewerbe_euer",
  SPOUSE_FREELANCE_EUER = "spouse_freelance_euer",
  SPOUSE_GEWERBE_EUER = "spouse_gewerbe_euer",
  RECEIVED_MESSAGES = "received_messages",
  VAT_DECLARATION = "declaration_vat",
  SPOUSE_VAT_DECLARATION = "spouse_declaration_vat",
}
